import { TypeChecker } from '@attain-apps/type-guards'

export enum Type {
  Bar = 'bar',
  Donut = 'donut',
  Scatter = 'scatter',
  Line = 'line',
  StackedBar = 'bar.stacked',
  Sunburst = 'sunburst',
  Venn = 'venn',
}
// Needs to be before namespace is defined
const TYPES: ReadonlySet<Type> = new Set(Object.values(Type) as Type[])
export namespace Type {
  export const ALL: readonly Type[] = Array.from(TYPES)
  export const isType = TypeChecker.Factory.oneOf(TYPES)
}
